module.exports = __webpack_public_path__ + "post-listing-block-7-image-_kZAihh.jpg";